export default {"src":"/_next/static/media/download-icon-active.ee5640c3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};